export default __webpack_public_path__ + "static/media/pay-stack-logo.aa1f9cb8.png";